import type { MiniSiteReview } from '@worki/shared';

/** The mean of whichever dimensions were scored, or null when none were. */
export function meanOf(scores: Array<number | null>): number | null {
  const given = scores.filter((score): score is number => score !== null && score > 0);
  if (given.length === 0) return null;
  return given.reduce((sum, score) => sum + score, 0) / given.length;
}

/**
 * What one review is worth out of five: the breakdown when it has one, and the
 * single score it was collected with when it does not. Same rule as the
 * server's average, so a card and the header cannot disagree.
 */
export const reviewScore = (review: MiniSiteReview) =>
  meanOf([review.ratingService, review.ratingTimeliness, review.ratingValue]) ?? review.rating;

/*
 * Stored out of five, shown out of ten. Nitzan's page reads "9.5" — the scale
 * Israeli review sites use — and doubling at the edge keeps every stored score,
 * and the server's average, exactly as they were.
 */
export const outOfTen = (score: number | null) => (score === null ? '—' : (score * 2).toFixed(1));
